import { Box } from '@components/design-system';
import { styled } from '@styles/stitches';

export const Directory = styled('div', {
  color: '$primaryFill',
  fontFamily: '$DMSans',
  padding: '$space$3 0',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
  zIndex: 1,

  '@bp1': {
    padding: '$space$1 0',
    flexDirection: 'row',
  },
});

export const Group = styled('div', {
  nav: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '$2',
  },

  a: {
    lineHeight: '1.5rem',
  },
});

export const Container = styled('div', {
  backgroundColor: '$primaryBackground',
  color: '$primaryFill',
  minHeight: '$space$1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexDirection: 'column-reverse',
  zIndex: 1,

  [`& ${Box}`]: {
    margin: '$space$3 0 0 0',
  },

  p: {
    margin: 0,
    marginLeft: '$space$3',
    color: '$secondaryFill',
    fontSize: 14,
    whiteSpace: 'pre-line',
  },

  '@bp1': {
    flexDirection: 'row',

    [`& ${Box}`]: {
      margin: 0,
    },
  },
});
